export const notification = {
    seeAll: false,
    show: false,
};